export default {
  namespaced: true,
  state: () => ({
    segmentosReserva: [],
    loading: false,
  }),
  getters: {
    getSegmentosReserva(state) {
      return state.segmentosReserva;
    },
    segmentosReserva(state) {
      return state.segmentosReserva;
    },
    isLoadingFamilias(state) {
      return state.loading;
    },
  },
  mutations: {
    setSegmentosReserva(state, data) {
      state.segmentosReserva = data;
    },
    setLoading(state, status) {
      state.loading = status;
    },
  },
  actions: {
    async getSegmentosReserva({ commit, rootGetters }) {
      commit("setLoading", true);
      try {
        const database = rootGetters.getFirebaseApp.database;
        const snapshot = await database.queryBuilder("/RVA/SegmentosReserva");
        if (snapshot && snapshot.exists()) {
          const val = snapshot.val() || {};
          const segmentosReserva = Object.entries(val)
            .filter(([, segmento]) => !segmento.Dlat)
            .map(([id, segmento]) => ({ id, ...segmento }));
          commit("setSegmentosReserva", segmentosReserva);
          return segmentosReserva;
        } else {
          commit("setSegmentosReserva", []);
          return [];
        }
      } catch (error) {
        console.error("Error al obtener SegmentosReserva:", error);
        commit("setSegmentosReserva", []);
        throw error;
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
